import { AppDropdown } from "@/shared/Components/AppDropdown";
import type { DropdownProps } from "antd/lib";
import type { FC, ReactNode } from "react";
import type { MenuIconType } from "./types";
import { MenuCallButton } from "./MenuCallButton";
import { DropdownContent } from "./DropdownContent";
import styles from "./styles.module.scss";

interface Props extends DropdownProps {
  content: ReactNode;
  children: ReactNode;
  iconType: MenuIconType;
  className?: string;
}

export const DropdownMenu: FC<Props> = ({ content, children, iconType, className, ...props }) => {
  return (
    <AppDropdown
      placement="bottomRight"
      trigger={["click"]}
      dropdownRender={() => <DropdownContent content={content} />}
      className={styles.dropdown}
      {...props}
    >
      <MenuCallButton className={className} icon={iconType} onClick={(e) => e.preventDefault()}>
        {children}
      </MenuCallButton>
    </AppDropdown>
  );
};
